import { CONFIG } from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
    appName: 'Core OnePage',
    frontend: 'https://onepage.builtoncore.com',
    apiHash: 'https://onepage.builtoncore.com/api/1.0',
    api: 'https://onepage.builtoncore.com/api/2.0',
    trustModel: false,
    authHeaders: {
        xServiceProvider: 'onepage-prod-frontend',
        'tenant-id': '69ae7ba0-3766-465e-a61e-e590087f64e2',
        'consumer-id': 'efaee42f-29b3-4ad9-9771-16b14b49e45a',
    },
    provider: 'onepage-prod-frontend',
    gtm: 'GTM-NGNB3SH2',
    multilingual: false,
    copyright: '&copy; ' + new Date().getFullYear() + ' Gallagher. All Rights Reserved.',
    demoMode: false,
    chatEnabled: false,
    isDarkModeEnabled: false,
    navigation: {
        navType: 'top',
        collapsibleSidenav: false,
        headerStyle: 'transparent',
        categoryNav: true,
    },
} as unknown as CONFIG;
